// extracted by mini-css-extract-plugin
export default {"root":"ConfirmEmail__root--2hjpV","dialog":"ConfirmEmail__dialog--3_Uqt","licenseBlock":"ConfirmEmail__licenseBlock--jhBFV","finalDialog":"ConfirmEmail__finalDialog--2QYDw"};